<main class="backImg">
  <section class="backImg">
    <div class="anonymous-div position">
      <div class="image-pos">
        <img
          src="../../../assets/images/blog-flower.svg"
          alt=""
          class="float-top"
        />
        <img
          src="../../../assets/images/blog-round-flower.svg"
          alt=""
          class="float-top"
        />
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-12 col-lg-8 text-center">
            <h1 class="h2-f-t text-capitalize">
              Exclusive Pricing Plans for Venues and Vendors
            </h1>
            <p class="paragraph" style="text-align: justify">
              For anyone who wants to book a wedding hall or take vendor
              service, Hamara Venue is accessible. However, we offer flexible
              pricing plans for venues and vendors to list their business and
              reach a broader audience. Whether you are a venue owner, musician,
              decor provider, mehndi artist, makeup artist, or offer catering
              services, Hamara Venue provides reasonable pricing for listing. We
              ensure you maximize your online exposure and increase your
              customer reach in every corner of Pakistan.
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-12">
            <ul
              class="nav nav-pills pricing_tabs_btn"
              id="pills-tab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link view-btn active"
                  id="monthly_billing_tab"
                  data-bs-toggle="pill"
                  data-bs-target="#monthly_billing"
                  type="button"
                  role="tab"
                  aria-controls="monthly_billing"
                  aria-selected="true"
                >
                  Venue Companies
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link view-btn"
                  id="annual_billing_tab"
                  data-bs-toggle="pill"
                  data-bs-target="#annual_billing"
                  type="button"
                  role="tab"
                  aria-controls="annual_billing"
                  aria-selected="false"
                >
                  Service Providers
                </button>
              </li>
              <!-- <li class="nav-item" role="presentation">
                <button class="nav-link view-btn active" id="monthly_billing_tab" data-bs-toggle="pill" (click)="getPricing('hall_owner')"
                  data-bs-target="#monthly_billing" type="button" role="tab" aria-controls="monthly_billing"
                  aria-selected="true">Venue Companies</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link view-btn" id="annual_billing_tab" data-bs-toggle="pill" (click)="getPricing('vendor')"
                  data-bs-target="#annual_billing" type="button" role="tab" aria-controls="annual_billing"
                  aria-selected="false">Service Providers</button>
              </li> -->
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="monthly_billing"
                role="tabpanel"
                aria-labelledby="monthly_billing_tab"
              >
                <ng-container *ngFor="let item of venueCompanies">
                  <div class="pricing-card">
                    <div class="pricing-header">
                      <span>{{ item.plan_title }}</span>
                      <div class="price">
                        <h2>{{ item.price | currency : "PKR " }}</h2>
                        <p>{{ item?.payment_type }}</p>
                      </div>
                      <p>{{ item?.description }}</p>
                      <div class="price_card_btns" *ngFor="let plan of plans">
                        <button class="view-btn">Get Started</button>
                        <!-- <button class="view-btn" (click)="openPaymentModal(plan)">Get Started</button> -->
                      </div>
                    </div>
                    <div class="pricing-body">
                      <span>Features</span>
                      <ul>
                        <ng-container *ngFor="let features of item.features">
                          <li>
                            <i class="bi bi-check-circle-fill"></i>
                            {{ features }}
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div
                class="tab-pane fade"
                id="annual_billing"
                role="tabpanel"
                aria-labelledby="annual_billing_tab"
              >
                <ng-container *ngFor="let item of serviceProviders">
                  <div class="pricing-card">
                    <div class="pricing-header">
                      <span>{{ item.plan_title }}</span>
                      <div class="price">
                        <h2>{{ item.price | currency : "PKR " }}</h2>
                        <p>{{ item?.payment_type }}</p>
                      </div>
                      <p>{{ item?.description }}</p>
                      <div class="price_card_btns">
                        <button class="view-btn">Get Started</button>
                      </div>
                    </div>
                    <div class="pricing-body">
                      <span>Features</span>
                      <ul>
                        <ng-container *ngFor="let features of item.features">
                          <li>
                            <i class="bi bi-check-circle-fill"></i>
                            {{ features }}
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-footer></app-footer>

  <!-- Payment Modal -->
  <div
    class="modal fade"
    id="paymentModal"
    tabindex="-1"
    aria-labelledby="paymentModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content" *ngIf="is_process_payment != 2">
        <div class="modal-header">
          <h5 class="modal-title" id="paymentModalLabel">Payment</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <ng-container *ngIf="is_process_payment == 0">
            <form class="">
              <div class="d-flex flex-column mt-4 gap-3">
                <div class="position-relative">
                  <label for="" class="form-check-label text-size-normal mb-8"
                    >Aard Number*</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="cardNumber"
                    [(ngModel)]="paymentDetails.cardNumber"
                    name="cardNumber"
                    placeholder="Card Number"
                  />
                </div>
                <div class="position-relative">
                  <label for="" class="form-check-label text-size-normal mb-8"
                    >Expiry Date*</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="expiryDate"
                    [(ngModel)]="paymentDetails.expiryDate"
                    name="expiryDate"
                    placeholder="Expiry Date"
                  />
                </div>
                <div class="position-relative">
                  <label for="" class="form-check-label text-size-normal mb-8"
                    >CVV*</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="cvv"
                    [(ngModel)]="paymentDetails.cvv"
                    name="cvv"
                    placeholder="CVV"
                  />
                </div>
              </div>
            </form>
          </ng-container>

          <ng-container *ngIf="is_process_payment == 1">
            <p class="text-center">
              Are you sure you want to purchase this package? Please confirm
              your selection.
            </p>
          </ng-container>
        </div>
        <div class="modal_btns text-center">
          <ng-container *ngIf="is_process_payment == 0">
            <button type="button" class="view-btn" (click)="processPayment()">
              Pay
            </button>
          </ng-container>

          <ng-container *ngIf="is_process_payment == 1">
            <button
              type="button"
              class="view-btn"
              (click)="openPaymentModal(plan)"
            >
              Change
            </button>
            <button type="button" class="view-btn" (click)="confirmPayment()">
              Confirm
            </button>
          </ng-container>
        </div>
      </div>
      <div class="modal-content text-center" *ngIf="is_process_payment == 2">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmationModalLabel">
            Thank You for Your Purchase!
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body text-center">
          <p>Your receipt has been uploaded successfully.</p>
          <p>Your {{ selectedPlan?.name }} plan is now active.</p>
        </div>
        <div class="modal_btns">
          <a href="/" class="view-btn" data-bs-dismiss="modal"
            >Go to Dashboard</a
          >
        </div>
      </div>
    </div>
  </div>
</main>
